import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFire, FaSearch, FaHeart, FaComment, FaUser, FaQuestionCircle, FaChevronDown, FaCog } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();
  const [navItems, setNavItems] = useState([]);
  const [showHelpMenu, setShowHelpMenu] = useState(false);

  useEffect(() => {
    // Rebuild navItems when user authentication state changes
    const updatedNavItems = [
      {
        path: '/encounters',
        icon: FaFire,
        label: 'Discover',
        active: location.pathname === '/encounters'
      },
      {
        path: '/people',
        icon: FaSearch,
        label: 'Search',
        active: location.pathname === '/people'
      },
      {
        path: '/matches',
        icon: FaHeart,
        label: 'Matches',
        active: location.pathname === '/matches'
      },
      {
        path: '/messages',
        icon: FaComment,
        label: 'Messages',
        active: location.pathname === '/messages'
      },
      {
        path: user ? `/user/${user.id}` : '/profile',
        icon: FaUser,
        label: 'Profile',
        active: location.pathname.startsWith('/user') || location.pathname === '/profile' ||
                location.pathname === '/likes' || location.pathname === '/visitors' ||
                location.pathname === '/settings' || location.pathname === '/matches'
      }
    ];
    setNavItems(updatedNavItems);
  }, [user, isAuthenticated, location.pathname]);

  const [helpItems, setHelpItems] = useState([
    { name: 'Help & Support', path: '/page/Support', icon: FaQuestionCircle },
    { name: 'Safety Tips', path: '/page/Safety Tips', icon: FaQuestionCircle },
    { name: 'About Us', path: '/page/About Us', icon: FaQuestionCircle },
    { name: 'Terms of Service', path: '/page/Terms of Service', icon: FaQuestionCircle },
    { name: 'Privacy Policy', path: '/page/Privacy Policy', icon: FaQuestionCircle },
  ]);

  useEffect(() => {
    // Add admin panel link for admin users
    const baseItems = [
      { name: 'Help & Support', path: '/page/Support', icon: FaQuestionCircle },
      { name: 'Safety Tips', path: '/page/Safety Tips', icon: FaQuestionCircle },
      { name: 'About Us', path: '/page/About Us', icon: FaQuestionCircle },
      { name: 'Terms of Service', path: '/page/Terms of Service', icon: FaQuestionCircle },
      { name: 'Privacy Policy', path: '/page/Privacy Policy', icon: FaQuestionCircle },
    ];

    if (user && user.role && (user.role.name === 'admin' || user.role.name === 'moderator')) {
      baseItems.unshift({ name: 'Admin Panel', path: '/admin', icon: FaCog });
    }

    setHelpItems(baseItems);
  }, [user]);

  return (
    <nav className="matchus-navbar">
      <div className="matchus-nav-container">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`matchus-nav-item ${item.active ? 'active' : ''}`}
            >
              <div className="matchus-nav-icon">
                <IconComponent />
              </div>
              <span className="matchus-nav-label">{item.label}</span>
            </Link>
          );
        })}

        {/* Help Menu */}
        <div className="relative">
          <button
            onClick={() => setShowHelpMenu(!showHelpMenu)}
            className="matchus-nav-item"
          >
            <div className="matchus-nav-icon">
              <FaQuestionCircle />
            </div>
            <span className="matchus-nav-label">Help</span>
            <FaChevronDown className={`ml-1 h-3 w-3 transition-transform ${showHelpMenu ? 'rotate-180' : ''}`} />
          </button>

          {showHelpMenu && (
            <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-48 z-50">
              {helpItems.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <Link
                    key={index}
                    to={item.path}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-pink-600 transition-colors"
                    onClick={() => setShowHelpMenu(false)}
                  >
                    <IconComponent className="h-4 w-4 mr-3" />
                    {item.name}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Overlay to close dropdown */}
      {showHelpMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowHelpMenu(false)}
        />
      )}
    </nav>
  );
};

export default Navbar;

